// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var ReactRender = require("../../../reason/utils/ReactRender.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var VisuallyHidden = require("@reach/visually-hidden").default;

function PaginationBoxRefetchable$NextPrevLink(props) {
  var __hasRightBorder = props.hasRightBorder;
  var children = props.children;
  var onClick = props.onClick;
  var href = props.href;
  var hasRightBorder = __hasRightBorder !== undefined ? __hasRightBorder : false;
  var base = "w-[30px] h-[30px] shrink-0 flex justify-center items-center relative";
  var borderClass = hasRightBorder ? "border-r border-zinc-300" : "";
  if (href !== undefined) {
    return JsxRuntime.jsx("a", {
                children: children,
                className: TailwindMerge.twMerge([
                      base,
                      borderClass
                    ]),
                href: href,
                onClick: (function ($$event) {
                    if ($$event.metaKey || $$event.ctrlKey) {
                      return ;
                    } else {
                      $$event.preventDefault();
                      return onClick();
                    }
                  })
              });
  } else {
    return JsxRuntime.jsx("div", {
                children: children,
                "aria-disabled": true,
                className: TailwindMerge.twMerge([
                      base,
                      borderClass,
                      "aria-disabled:opacity-30"
                    ])
              });
  }
}

var NextPrevLink = {
  make: PaginationBoxRefetchable$NextPrevLink
};

function PaginationBoxRefetchable(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs(PaginationBoxRefetchable$NextPrevLink, {
                      href: props.previousPagePath,
                      onClick: props.onClickPrevious,
                      children: [
                        JsxRuntime.jsx(VisuallyHidden, {
                              children: "Previous page"
                            }),
                        JsxRuntime.jsx("span", {
                              children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                    icon: "ArrowLeft",
                                    size: 15
                                  }),
                              "aria-hidden": true,
                              className: "flex text-zinc-600"
                            })
                      ],
                      hasRightBorder: true
                    }),
                ReactRender.fromOption(props.pageInfo, (function (param) {
                        return JsxRuntime.jsx("div", {
                                    children: "Page " + param.currentPage.toString() + " of " + param.totalPages.toString(),
                                    className: "h-[30px] shrink-0 flex justify-center items-center relative px-[15px] text-zinc-600 border-r border-zinc-300"
                                  });
                      })),
                JsxRuntime.jsxs(PaginationBoxRefetchable$NextPrevLink, {
                      href: props.nextPagePath,
                      onClick: props.onClickNext,
                      children: [
                        JsxRuntime.jsx(VisuallyHidden, {
                              children: "Next page"
                            }),
                        JsxRuntime.jsx("span", {
                              children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                    icon: "ArrowRight",
                                    size: 15
                                  }),
                              "aria-hidden": true,
                              className: "flex text-zinc-600"
                            })
                      ]
                    })
              ],
              className: "inline-flex justify-center items-center border border-zinc-300 rounded bg-white relative"
            });
}

var make = PaginationBoxRefetchable;

exports.NextPrevLink = NextPrevLink;
exports.make = make;
/* Icon__Jsx3 Not a pure module */
